export default __webpack_public_path__ + "static/media/pig-blue.984d4582.svg";